import Global from "../utils/Global";
import ApiClient from "./ApiClient";

export const fetchClients = async ({ token, page, filterBy, searchQuery, pageSize }) => {
    const response = await ApiClient.get('/api/clients', {
        params: {
            search_query: searchQuery,
            page,
            page_size: pageSize,
            filter_by: filterBy,
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });

    return response.data;
}

export const exportClients = async ({ token, filters }) => {
    try {
        const queryString = new URLSearchParams(filters).toString();
        const response = await fetch(Global.baseURL + `/api/clients/export?${queryString}`, {
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + token
            }
        });

        if (!response.ok) {
            throw new Error('Failed to export clients');
        }

        return response.blob();
    } catch (error) {
        // Handle error
        console.error('Error exporting clients:', error);
        throw error;
    }
}

export const downloadCommissionStatement = async ({ token, id }) => {
    try {
        const response = await fetch(Global.baseURL + `/api/clients/download_commission_statement/${id}`, {
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + token
            }
        });

        if (!response.ok) {
            throw new Error('Failed to download commission statement');
        }

        return response.blob();
    } catch (error) {
        console.error('Error downloading commission statement:', error);
        throw error;
    }
};